import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { ORG_LINE1, ORG_LINE2, PHOTO_PATH } from '../constants';

const DigitalStamp = () => (
  <svg width="110" height="52" viewBox="0 0 110 52" className="digital-stamp">
    <rect x="2" y="2" width="106" height="48" rx="6" fill="none" stroke="#2e7d32" strokeWidth="2" />
    <rect x="5" y="5" width="100" height="42" rx="4" fill="none" stroke="#2e7d32" strokeWidth="0.5" strokeDasharray="3,2" />
    <text x="55" y="16" textAnchor="middle" fill="#1b5e20" fontSize="8" fontWeight="bold">✓ DIGITALLY SIGNED</text>
    <line x1="12" y1="22" x2="98" y2="22" stroke="#2e7d32" strokeWidth="0.7" />
    <text x="55" y="32" textAnchor="middle" fill="#2e7d32" fontSize="7" fontWeight="bold">डिजिटल स्वाक्षरी</text>
    <line x1="12" y1="37" x2="98" y2="37" stroke="#2e7d32" strokeWidth="0.7" />
    <text x="55" y="46" textAnchor="middle" fill="#1b5e20" fontSize="6">Authorized Officer / अधिकृत अधिकारी</text>
  </svg>
);

function Receipt({ data, onNewRegistration, onLogout, onGoToDashboard }) {
  const receiptRef = useRef(null);

  if (!data) return null;

  const now = new Date();
  const dateStr = now.toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' });
  const timeStr = now.toLocaleTimeString('en-IN', { timeZone: 'Asia/Kolkata' });

  const qrUrl = `${window.location.origin}/?verify=${data.aadhaarNumber}`;

  const getImageUrl = () => {
    const baseUrl = window.location.origin;
    return baseUrl + PHOTO_PATH;
  };

  const renderCopy = (copyLabel, copyLabelMr) => (
    <div className="receipt-section">
      <div className="receipt-header">
        <div className="receipt-header-left">
          <img
            src={getImageUrl()}
            alt="Gopinath Munde"
            className="receipt-photo"
          />
        </div>
        <div className="receipt-header-center">
          <div className="dept-name">{ORG_LINE1}</div>
          <div className="dept-name-sub">{ORG_LINE2}</div>
          <div className="receipt-title">Registration Acknowledgement / नोंदणी पावती</div>
        </div>
        <div className="receipt-header-right">
          <div className="copy-badge">{copyLabel}<br />{copyLabelMr}</div>
        </div>
      </div>

      <div className="receipt-section-header">
        <span className="section-title-icon">&#9632;</span> Applicant Details / अर्जदार तपशील
      </div>

      <div className="receipt-body">
        <table className="receipt-table">
          <tbody>
            <tr><td className="label-cell">Kutumb Kramank (कुटुंब क्रमांक)</td><td className="value-cell">{data.kutumbKramank}</td></tr>
            <tr><td className="label-cell">Sadasya Kramank (सदस्य क्रमांक)</td><td className="value-cell">{data.sadasyaKramank}</td></tr>
            <tr><td className="label-cell">Kamgar Name (कामगार नाव)</td><td className="value-cell">{data.kamgarName || '-'}</td></tr>
            <tr><td className="label-cell">District (जिल्हा)</td><td className="value-cell">{data.district}</td></tr>
            <tr><td className="label-cell">Taluka (तालुका)</td><td className="value-cell">{data.taluka}</td></tr>
            <tr><td className="label-cell">Village (गाव)</td><td className="value-cell">{data.village}</td></tr>
            <tr><td className="label-cell">Mobile Number (मोबाईल क्रमांक)</td><td className="value-cell">{data.mobile}</td></tr>
            <tr><td className="label-cell">Aadhaar Number (आधार क्रमांक)</td><td className="value-cell">{data.aadhaarNumber}</td></tr>
            <tr><td className="label-cell">Arj Kramank (अर्ज क्रमांक)</td><td className="value-cell">{data.arjKramank}</td></tr>
            <tr><td className="label-cell">Aapla Arj Kramank (आपला अर्ज क्रमांक)</td><td className="value-cell">{data.aaplaArjKramank || '-'}</td></tr>
            <tr><td className="label-cell">Kamgar Prakar (कामगार प्रकार)</td><td className="value-cell">{data.kamgarPrakar}</td></tr>
            <tr><td className="label-cell">Anubhavi Varsh (अनुभवी वर्ष)</td><td className="value-cell">{data.anubhaviVarsh}</td></tr>
            <tr><td className="label-cell">Kutumb Sadasya (कुटुंब सदस्य)</td><td className="value-cell">{data.kutumbSadasya || '-'}</td></tr>
            <tr><td className="label-cell">Status (स्थिती)</td><td className="value-cell" style={{ fontWeight: 'bold', color: '#1a237e' }}>{data.status || 'Registration Done'}</td></tr>
          </tbody>
        </table>

        <div className="receipt-qr-area">
          <div className="qr-label">QR Code</div>
          <div className="qr-box">
            <QRCodeSVG value={qrUrl} size={100} level="M" includeMargin={true} />
          </div>
          <div className="qr-hint">Scan for details / स्कॅन करा</div>
          <div className="receipt-date-area">
            <div className="date-row"><span className="date-lbl">Date / तारीख:</span> <span>{dateStr}</span></div>
            <div className="date-row"><span className="date-lbl">Time / वेळ:</span> <span>{timeStr}</span></div>
          </div>
        </div>
      </div>

      <div className="receipt-section-header">
        <span className="section-title-icon">&#9632;</span> Surveyor Details / सर्वेक्षक तपशील
      </div>

      <div className="surveyor-inline">
        <span className="surveyor-item"><strong>Surveyor Contact (सर्वेक्षक संपर्क):</strong> {data.surveyorContact}</span>
        <span className="surveyor-sep">|</span>
        <span className="surveyor-item"><strong>Surveyor Email (सर्वेक्षक ईमेल):</strong> {data.surveyorEmail}</span>
      </div>

      <div className="signature-section">
        <div className="sig-box">
          <div className="sig-line"></div>
          <div className="sig-label">Surveyor Signature<br />सर्वेक्षक स्वाक्षरी</div>
        </div>
        <div className="sig-box">
          <div className="sig-line"></div>
          <div className="sig-label">Applicant Signature<br />अर्जदार स्वाक्षरी</div>
        </div>
        <div className="sig-box sig-stamp-box">
          <DigitalStamp />
        </div>
      </div>

      <div className="receipt-footer">
        <div className="thank-you">Thank You / धन्यवाद</div>
        <div>{ORG_LINE2}</div>
        <div className="free-service-note">निःशुल्क सेवा - कोई छुपी हुई चार्जेस नहीं / Free Service - No Hidden Charges</div>
        <div className="footer-note">This is a computer-generated acknowledgement slip / ही संगणकाद्वारे तयार केलेली पावती आहे</div>
      </div>
    </div>
  );

  const handleDownloadPDF = async () => {
    const element = receiptRef.current;
    if (!element) return;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`registration-receipt-${Date.now()}.pdf`);
  };

  const handlePrint = () => {
    const printContent = receiptRef.current;
    if (!printContent) return;

    const printWindow = window.open('', '_blank');
    const baseUrl = window.location.origin;

    let html = printContent.innerHTML;
    html = html.replace(/src="\/images\//g, `src="${baseUrl}/images/`);

    printWindow.document.write(`
      <html>
        <head>
          <title>Print Receipt / पावती प्रिंट करा</title>
          <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" rel="stylesheet" />
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body { font-family: 'Roboto', sans-serif; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            @page { size: A4 portrait; margin: 3mm; }
            .receipt-a4 { width: 204mm; min-height: 291mm; padding: 2mm; font-size: 11px; }
            .receipt-section { border: 1.5px solid #1a237e; padding: 3px; margin-bottom: 2px; }
            .receipt-header { display: flex; align-items: center; gap: 6px; border-bottom: 1.5px solid #1a237e; padding-bottom: 3px; margin-bottom: 2px; }
            .receipt-header-left { flex-shrink: 0; }
            .receipt-photo { width: 36px; height: 42px; object-fit: cover; border-radius: 3px; }
            .receipt-header-center { flex: 1; text-align: center; }
            .receipt-header-right { flex-shrink: 0; text-align: right; }
            .copy-badge { background: #ffcdd2; color: #b71c1c; padding: 2px 6px; border-radius: 3px; font-size: 8.5px; font-weight: 700; line-height: 1.3; }
            .dept-name { font-size: 12px; font-weight: 700; line-height: 1.2; }
            .dept-name-sub { font-size: 10px; font-weight: 600; line-height: 1.2; color: #1a237e; }
            .receipt-title { font-size: 12px; font-weight: 700; color: #1a237e; margin-top: 2px; text-transform: uppercase; letter-spacing: 0.5px; }
            .receipt-section-header { background: #1a237e; color: white; padding: 3px 6px; font-size: 11px; font-weight: 700; margin-bottom: 2px; border-radius: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
            .section-title-icon { color: #ffc107; margin-right: 4px; }
            .receipt-body { display: flex; gap: 4px; }
            .receipt-table { flex: 1; border-collapse: collapse; }
            .receipt-table td { padding: 1px 4px; border: 1px solid #ccc; font-size: 17px; white-space: nowrap; }
            .receipt-table .label-cell { background: #e8eaf6; font-weight: 600; width: 52%; color: #1a237e; font-size: 9.5px; }
            .receipt-table .value-cell { font-weight: 500; }
            .surveyor-table { margin-bottom: 2px; }
            .surveyor-table td { padding: 2px 4px; white-space: nowrap; }
            .receipt-qr-area { width: 110px; text-align: center; display: flex; flex-direction: column; align-items: center; gap: 2px; }
            .qr-label { font-size: 10px; font-weight: 700; color: #1a237e; }
            .qr-box { border: 1px solid #ccc; padding: 2px; background: white; }
            .qr-hint { font-size: 8px; color: #888; }
            .receipt-date-area { font-size: 8px; text-align: left; width: 100%; margin-top: 2px; }
            .date-row { display: flex; justify-content: space-between; padding: 1px 2px; }
            .date-lbl { font-weight: 600; color: #1a237e; }
            .signature-section { display: flex; justify-content: space-between; align-items: flex-end; margin-top: 2px; padding-top: 2px; border-top: 1px solid #ccc; }
            .sig-box { text-align: center; width: 30%; }
            .sig-line { border-bottom: 1px solid #333; margin: 0 4px 2px; height: 14px; }
            .sig-label { font-size: 8px; color: #555; font-weight: 500; line-height: 1.3; }
            .sig-stamp-box { width: 34%; }
            .digital-stamp { width: 100px; height: 48px; }
            .receipt-footer { text-align: center; border-top: 1px solid #ccc; padding-top: 1px; margin-top: 2px; font-size: 8px; color: #666; }
            .receipt-footer .thank-you { font-size: 6px; font-weight: 700; color: #1a237e; margin-bottom: 1px; }
            .footer-note { font-size: 6px; }
            .free-service-note { font-size: 6px; font-weight: 700; color: #2e7d32; margin-top: 2px; padding: 3px 6px; background: #e8f5e9; border: 1px solid #a5d6a7; border-radius: 3px; display: inline-block; }
            .copy-divider { text-align: center; border-top: 1.5px dashed #999; margin: 2px 0; padding: 2px; font-size: 8px; color: #999; }
          </style>
        </head>
        <body>
          <div class="receipt-a4">${html}</div>
        </body>
      </html>
    `);
    printWindow.document.close();
    setTimeout(() => { try { printWindow.print(); } catch (e) { } }, 500);
  };

  return (
    <div>
      <div className="success-card">
        <div className="success-icon">&#10004;</div>
        <h2>Registration Submitted Successfully! / नोंदणी यशस्वीरित्या सबमिट झाली!</h2>
        <p>
          Your registration has been recorded. Please download or print your receipt below.<br />
          तुमची नोंदणी रेकॉर्ड झाली आहे. कृपया खाली तुमची पावती डाउनलोड किंवा प्रिंट करा.
        </p>
        <div className="receipt-actions">
          <button className="btn-primary btn-receipt-action" onClick={handleDownloadPDF}>
            &#128196; Download PDF / PDF डाउनलोड करा
          </button>
          <button className="btn-secondary" onClick={handlePrint}>
            &#128424; Print Receipt / पावती प्रिंट करा
          </button>
          <button className="btn-secondary" onClick={onNewRegistration}>
            + New Registration / नवीन नोंदणी
          </button>
          {onGoToDashboard && (
            <button className="btn-secondary btn-dashboard-nav" onClick={onGoToDashboard}>
              Go to Dashboard / डॅशबोर्डवर जा
            </button>
          )}
          <button className="btn-logout" onClick={onLogout}>
            Logout / लॉगआउट
          </button>
        </div>
      </div>

      <div className="receipt-container">
        <div className="receipt-a4" ref={receiptRef}>
          {renderCopy('VENDOR COPY', 'विक्रेता प्रत')}
          <div className="copy-divider">- - - - - - - - - - CUT HERE / येथे कट करा - - - - - - - - - -</div>
          {renderCopy('CUSTOMER COPY', 'ग्राहक प्रत')}
        </div>
      </div>
    </div>
  );
}

export default Receipt;
